import React, { useState, forwardRef, useImperativeHandle, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { DatePicker, } from 'meinian-package/src/component'
import moment from 'moment'
import request from 'meinian-package/src/utils/request'
import cloneDeep from 'lodash/cloneDeep'
import LineChart from 'view/components/newCollectLineChart'
import MemberContribute from 'view/components/memberContribute'
import MemberStatistics from 'view/components/memberStatistics'
import useAsyncLoading from 'common/hooks/useAsyncLoading'
import { useLatest } from 'ahooks'
import AnalysisOverview from '../../../../components/analysisOverview'
import styles from './index.module.less'

export default forwardRef(({ baseParams }, ref) => {
  const navigate = useNavigate()
  const [params, setParams] = useState({})
  const paramsRef = useLatest(params)
  const [collectOption, setCollectOption] = useState([])
  const [checkOption, setCheckOption] = useState([])
  const collectData = useAsyncLoading({ fetchData: (_params) => fetchCollectData(_params), params: baseParams })
  const checkData = useAsyncLoading({ fetchData: (_params) => fetchCheckData(_params), params: baseParams })
  const newCollectRef = useRef(null)
  const memberContributeRef = useRef(null)
  const memberStatisticsRef = useRef(null)

  useImperativeHandle(ref, () => ({
    fetchCollectData: collectData.onUpdate,
    fetchCheckData: checkData.onUpdate,
    fetchNewCollectData,
    fetchMemberContributeData,
    fetchMemberStatisticsData
  }))

  const fetchCollectDetail = async (_baseParams) => {
    const result = await request.sget('zhikuan/mn/collect-statistic/v2/collect-detail', _baseParams, 'collect_statistic_collect_detail')
    return result
  }

  // 保证在暴露出去的方法执行的时候 会带着当前层的params获取数据
  const fetchNewCollectData = (_baseParams) => {
    newCollectRef.current?.onUpdate({ ..._baseParams, ...paramsRef.current })
  }

  const fetchMemberContributeData = (_baseParams) => {
    memberContributeRef?.current?.onUpdate({ ..._baseParams, ...paramsRef.current })
  }

  const fetchMemberStatisticsData = (_baseParams) => {
    memberContributeRef?.current?.onUpdate({ ..._baseParams, ...paramsRef.current })
  }

  const fetchCollectData = async (_baseParams) => {
    const _params = cloneDeep(_baseParams)
    delete _params.startTime
    delete _params.endTime
    const result = await request.sget('zhikuan/mn/collect-statistic/v2/collect-summary', _params, 'collect_statistic_collect_summary')
    const _option = [{
      name: '今日采集',
      number: result.todayCollect,
      trigger: 'text',
      params: {
        ..._baseParams,
        startTime: moment().format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD'),
      }
    }, {
      name: '昨日采集',
      number: result.yesterdayCollect,
      trigger: 'text',
      params: {
        ..._baseParams,
        startTime: moment().subtract(1, 'd').format('YYYY-MM-DD'),
        endTime: moment().subtract(1, 'd').format('YYYY-MM-DD')
      }
    }, {
      name: '款式总计',
      number: result.allCollect,
      trigger: 'text',
      params: _baseParams
    },
    ]
    if (!_baseParams.userId) {
      _option.push({
        name: '重复采集',
        number: result.duplicateCollect,
        trigger: 'click'
      })
    }
    setCollectOption([..._option])
  }

  const fetchCheckData = async (_baseParams) => {
    const result = await request.sget('zhikuan/mn/collect-statistic/v2/review-summary', _baseParams, 'collect_statistic_review_summary')
    setCheckOption([{
      name: '未提交',
      number: result.uncommitted,
      trigger: false
    }, {
      name: '待审核',
      number: result.pending,
      trigger: false
    }, {
      name: '已通过',
      number: result.pass,
      trigger: false
    }, {
      name: '已拒回',
      number: result.fail,
      trigger: false
    }])
  }

  const fetchData = (_params) => {
    newCollectRef.current?.onUpdate({ ...baseParams, ..._params })
    memberContributeRef?.current?.onUpdate({ ...baseParams, ..._params })
    memberStatisticsRef?.current?.onUpdate({ ...baseParams, ..._params })
  }

  return (<div>
    <section className={styles['analysis-overview']}>
      <AnalysisOverview
        title="采集概览"
        fetchData={fetchCollectDetail}
        loading={collectData.loading}
        option={collectOption}
        style={{ marginRight: '24px' }}
        onClick={() => { navigate('/home/analysis/repeatCollect') }}
      />
      <AnalysisOverview
        loading={checkData.loading}
        option={checkOption}
        title="审核概览"
      />
    </section>
    <div style={{ textAlign: 'right', padding: '8px 0' }}>
      <DatePicker
        startTime={params.startTime}
        endTime={params.endTime}
        noneText="统计时间"
        onChange={([startTime, endTime]) => {
          fetchData({ startTime, endTime }, '统计时间')
          setParams({ startTime, endTime })
        }}
      />
    </div>
    <LineChart
      baseParams={{ ...baseParams, ...paramsRef.current }}
      ref={newCollectRef}
    />
    {
        !baseParams.userId && <>
          <MemberContribute
            style={{ marginTop: '32px' }}
            baseParams={{ ...baseParams, ...paramsRef.current }}
            ref={memberContributeRef}
            menuItemNameWidth={80}
            disabled
            menuOption={{ style: { width: 240 } }}
          />
          <MemberStatistics
            style={{ marginTop: '32px' }}
            baseParams={{ ...baseParams, ...paramsRef.current }}
            ref={memberStatisticsRef}
          />
        </>
    }
  </div>
  )
})
